export default __webpack_public_path__ + "static/media/globe-header-gold.7b2c61e3.svg";